enum AuthFormType {
  Basic = 'basic',
  Token = 'token',
}

type BaseUrlForm = {
  baseUrl: string;
};

type BasicAuthForm = {
  email: string;
  password: string;
};

type TokenAuthForm = {
  email: string;
  apiToken: string;
};

export { AuthFormType };
export type { BaseUrlForm, BasicAuthForm, TokenAuthForm };
